module.exports = "<div class=\"row\">\n  <a class=\"waves-effect waves-light btn\" [routerLink]=\"['/login-parceiro',{ cdParceiro: '02_FORD'}]\" target=\"_blank\">Ford</a>\n  <a class=\"waves-effect waves-light btn\" [routerLink]=\"['/login-parceiro',{ cdParceiro: '03_JEEP'}]\" target=\"_blank\">Jeep</a>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/app/parceiros/parceiros.component.html
// module id = ../../../../../src/app/parceiros/parceiros.component.html
// module chunks = main